import { useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/lib/currency";

export default function Wallet() {
  const { t } = useTranslation();
  const { fmt, meta } = useCurrency();
  const [balance, setBalance] = useState(0);
  const [amount, setAmount] = useState(1000);
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();

  const load = useCallback(() => api.get("/wallet").then(({ data }) => setBalance(data.balance)), []);
  useEffect(() => { load(); }, [load]);

  const deposit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/wallet/deposit", { amount: Number(amount) });
      toast.success(`+ ${fmt(Number(amount))}`);
      await load(); await refresh();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-[800px] mx-auto px-6 py-12">
      <div className="font-mono-label text-[11px] text-[#002FA7]">⎯⎯ {t("wal_tag")}</div>
      <h1 className="font-display text-5xl font-black mt-2">{t("wal_title")}</h1>

      <div className="border border-black p-8 mt-10 bg-black text-white">
        <div className="font-mono-label text-[10px] text-zinc-400">{t("wal_current")}</div>
        <div data-testid="wallet-balance" className="font-display text-5xl md:text-6xl font-black mt-2 tracking-tight tabular-nums break-all">{fmt(balance)}</div>
      </div>

      <form onSubmit={deposit} className="border border-black/10 p-6 mt-6 space-y-4">
        <div>
          <div className="font-mono-label text-[10px] text-[#002FA7]">⎯⎯ {t("wal_topup_tag")}</div>
          <div className="font-display text-2xl font-bold mt-2">{t("wal_topup_title")}</div>
        </div>
        <Label className="font-mono-label text-[10px]">{t("wal_amount")} (USD)</Label>
        <Input data-testid="topup-amount" type="number" min={1} value={amount} onChange={(e)=>setAmount(e.target.value)} className="rounded-none h-11"/>
        <Button data-testid="topup-submit" type="submit" disabled={busy}
          className="rounded-none bg-[#002FA7] hover:bg-[#001F70] h-11 font-mono-label text-xs">
          {busy ? t("processing") : `${t("wal_add_btn")} ${fmt(Number(amount)||0)} ←`}
        </Button>
      </form>
    </div>
  );
}
